import { Box, BoxProps, Text, VStack } from "@chakra-ui/react";

interface WarningBoxProps extends BoxProps {
  title: string;
  description: string;
}

const WarningBox = ({ title, description, ...props }: WarningBoxProps) => {
  return (
    <Box
      w="full"
      p={4}
      borderRadius="xl"
      border="1px solid"
      backgroundColor="yellow.50"
      borderColor="gray.200"
      {...props}
    >
      <VStack spacing={1} alignItems="flex-start">
        <Text fontWeight={"semibold"}>{title}</Text>
        <Text fontSize={"sm"} color={"gray.500"}>
          {description}
        </Text>
      </VStack>
    </Box>
  );
};

export default WarningBox;
